module.exports = __webpack_public_path__ + "static/img/icon-1.dddbfcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/icon-1.png
// module id = 4B8F
// module chunks = 0